import { Option } from './types'

export const sectorFocusOptions: Array<Option> = [
  { value: 'Investment banking', label: 'Investment banking' },
  { value: 'Corporate finance', label: 'Corporate finance' },
  { value: 'Project finance', label: 'Project finance' },
  { value: 'Research', label: 'Research' },
  { value: 'Rating agency', label: 'Rating agency' },
  {
    value: 'Energy trading & risk management',
    label: 'Energy trading & risk management',
  },
  { value: 'Hedge fund', label: 'Hedge fund' },
  { value: 'Private equity', label: 'Private equity' },
  { value: 'Securities trading', label: 'Securities trading' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'Recruitment', label: 'Recruitment' },
  { value: 'IPP', label: 'IPP' },
  { value: 'Other', label: 'Other' },
]
